import { render, staticRenderFns } from "./NotesUpdateView.vue?vue&type=template&id=a44b05f2&scoped=true"
import script from "./NotesUpdateView.vue?vue&type=script&lang=js"
export * from "./NotesUpdateView.vue?vue&type=script&lang=js"
import style0 from "./NotesUpdateView.vue?vue&type=style&index=0&id=a44b05f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44b05f2",
  null
  
)

export default component.exports